import React from "react";

import net123 from "../../assets/customers/123net.svg";
import bluezilla from "../../assets/customers/bluezilla.svg";
import cablebahamas from "../../assets/customers/cablebahamas.png";
import cloudns from "../../assets/customers/cloudns.png";
import coinpayments from "../../assets/customers/coinpayments.svg";
import egi from "../../assets/customers/egi.png";
import enovum from "../../assets/customers/enovum.png";
import hover from "../../assets/customers/hovernetworks.svg";
import iridium from "../../assets/customers/iridium.svg";
import keyinfo from "../../assets/customers/keyinfo.png";
import limestone from "../../assets/customers/limestone.svg";
import massivegrid from "../../assets/customers/massivegrid.svg";
import mojohost from "../../assets/customers/mojohost.png";
import namehero from "../../assets/customers/namehero.svg";
import reliablesite from "../../assets/customers/reliablesite.svg";
import spectrumvoip from "../../assets/customers/spectrumvoip.svg";
import uhaul from "../../assets/customers/uhaul.svg";
import velas from "../../assets/customers/velas.svg";
import vtx1 from "../../assets/customers/vtx1.png";
import zenlayer from "../../assets/customers/zenlayer.svg";

import hackthearmy from "../../assets/pages/home/awards/hack-the-army.png";
import hacktheairforce from "../../assets/pages/home/awards/hack-the-air-force.png";
import hackthepentagon from "../../assets/pages/home/awards/hack-the-pentagon.png";

const CustomersAndAwards = (props) => (
  <section className="customers-section">
    <div className="customers-inner">
      <h5 className="customers-heading">Our Customers Include</h5>
      <div className="customers-images">
        <a href="https://www.uhaul.com" target="_blank">
          <img src={uhaul} className="bigger" alt="U-Haul" />
        </a>
        <a href="https://www.iridium.com" target="_blank">
          <img
            src={iridium}
            className="bigger"
            alt="Iridium Satellite Communications"
          />
        </a>
        <a href="https://www.cloudns.net" target="_blank">
          <img src={cloudns} alt="ClouDNS" />
        </a>
        <a href="https://zenlayer.com" target="_blank">
          <img src={zenlayer} className="bigger" alt="Zenlayer" />
        </a>
        <a href="https://mojohost.com" target="_blank">
          <img src={mojohost} alt="MojoHost" />
        </a>
        <a href="https://www.coinpayments.net" target="_blank">
          <img src={coinpayments} className="bigger" alt="CoinPayments" />
        </a>
        <a href="https://www.rev.bs/" target="_blank">
          <img src={cablebahamas} className="bigger" alt="Cable Bahamas" />
        </a>
        <a href="https://www.vtx1.net" target="_blank">
          <img src={vtx1} className="smaller" alt="VTX1 Companies" />
        </a>
        <a
          href="https://convergetp.com/portfolio-of-companies/keyinfo/"
          target="_blank"
        >
          <img src={keyinfo} alt="Key Information Systems" />
        </a>
        <a href="https://hovernetworks.com" target="_blank">
          <img src={hover} className="bigger" alt="Hover Networks" />
        </a>
        <a href="https://www.limestonenetworks.com/" target="_blank">
          <img src={limestone} className="bigger" alt="Limestone Networks" />
        </a>
        <a href="https://velas.com/" target="_blank">
          <img src={velas} alt="Velas Blockchain" />
        </a>
        <a href="https://www.reliablesite.net" target="_blank">
          <img src={reliablesite} className="bigger" alt="ReliableSite" />
        </a>
        <a href="https://egihosting.com" target="_blank">
          <img src={egi} className="bigger" alt="Energy Group Networks" />
        </a>
        <a href="https://bluezilla.vc" target="_blank">
          <img src={bluezilla} className="bigger" alt="BlueZilla" />
        </a>
        <a href="http://www.namehero.com" target="_blank">
          <img src={namehero} alt="NameHero" />
        </a>
        <a href="https://www.spectrumvoip.com" target="_blank">
          <img src={spectrumvoip} className="biggest" alt="SpectrumVOIP" />
        </a>
        <a href="https://enovumdc.com" target="_blank">
          <img src={enovum} className="bigger" alt="Enovum Data Centers" />
        </a>
        <a href="https://www.123.net" target="_blank">
          <img src={net123} className="smaller" alt="123NET" />
        </a>
        <a href="https://massivegrid.com" target="_blank">
          <img src={massivegrid} className="bigger" alt="MassiveGRID" />
        </a>
      </div>
    </div>
    <div className="customers-inner">
      <h5 className="customers-heading awards">Awards</h5>
      <div className="awards-images">
        <a href="https://hackerone.com/hackthearmy" target="_blank">
          <img src={hackthearmy} alt="Hack the U.S. Army" />
        </a>
        <a
          href="https://www.hackerone.com/blog/announcing-the-largest-dod-bug-bounty-challenge-ever-hack-the-air-force"
          target="_blank"
        >
          <img src={hacktheairforce} alt="Hack the U.S. Air Force" />
        </a>
        <a
          href="https://hackerone.com/resources/hack-the-pentagon"
          target="_blank"
        >
          <img src={hackthepentagon} alt="Hack the Pentagon" />
        </a>
      </div>
    </div>
  </section>
);

export default CustomersAndAwards;



// WEBPACK FOOTER //
// ./src/components/generic/customersAndAwards.js